import React, { useEffect, useState } from "react";
import { animateScroll as scroll } from 'react-scroll';

import './style.css';


const Filtro = (props) => {
    const {distance, setDistance, listaRating, setListaRating, abrirFiltro, setAbrirFiltro} = props;

    const [rating, setRating] = useState([]);
    const [distanciaTemp, setDistanciaTemp] = useState(25);

    const handleCheckBox = (e) => {
        if (e.target.checked){
            setRating([...listaRating,e.target.value])
        }else{
            setRating(listaRating.filter(item => item !== e.target.value))
        }
    }

    const manejarFiltro = () => {
        if(abrirFiltro){
            scroll.scrollToTop()
            setAbrirFiltro(false)
        }
        setDistance(distanciaTemp)
        setListaRating(rating)
    }

    const renderStars = (count) =>
        Array.from({ length: count }).map((_, index) => (
        <svg
            key={index}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#FFC10E"
            className="bi bi-star-fill me-1"
            viewBox="0 0 16 16"
        >
            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 
            4.898.696c.441.062.612.636.282.95l-3.522 
            3.356.83 4.73c.078.443-.36.79-.746.592L8 
            13.187l-4.389 2.256z" />
        </svg>
    ));

    return (
        // <div className="container-box">
        //     <h1 className="filtro-heading">FILTRAR RESULTADOS</h1>
        //     <div className="filtro-box">
        //         <div className="bloque">
        //             <strong>Valoración</strong>
        //             <div className="filtro-checkbox">
        //                 <input type="checkbox" value={5} onClick={(e)=>{handleCheckBox(e)}}/>
        //                 <div className="filtro-label">
        //                     {
        //                         Array.from({ length: 5 }).map(numero => (
        //                             <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#FFC10E" class="bi bi-star-fill" viewBox="0 0 16 16">
        //                                 <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
        //                             </svg>
        //                         ))
        //                     }
        //                 </div>
        //             </div>
        //             <div className="filtro-checkbox">
        //                 <input type="checkbox"  value={4} onClick={(e)=>{handleCheckBox(e)}}/>
        //                 <div className="filtro-label">
        //                     {
        //                         Array.from({ length: 4 }).map(numero => (
        //                             <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#FFC10E" class="bi bi-star-fill" viewBox="0 0 16 16">
        //                                 <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
        //                             </svg>
        //                         ))
        //                     }
        //                 </div>
        //             </div>
        //             <div className="filtro-checkbox">
        //                 <input type="checkbox"  value={3} onClick={(e)=>{handleCheckBox(e)}}/>
        //                 <div className="filtro-label">
        //                     {
        //                         Array.from({ length: 3 }).map(numero => (
        //                             <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#FFC10E" class="bi bi-star-fill" viewBox="0 0 16 16">
        //                                 <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
        //                             </svg>
        //                         ))
        //                     }
        //                 </div>
        //             </div>
        //             <div className="filtro-checkbox">
        //                 <input type="checkbox"  value={2} onClick={(e)=>{handleCheckBox(e)}}/>
        //                 <div className="filtro-label">
        //                     {
        //                         Array.from({ length: 2 }).map(numero => (
        //                             <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#FFC10E" class="bi bi-star-fill" viewBox="0 0 16 16">
        //                                 <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
        //                             </svg>
        //                         ))
        //                     }
        //                 </div>
        //             </div>
        //             <div className="filtro-checkbox">
        //                 <input type="checkbox"  value={1} onClick={(e)=>{handleCheckBox(e)}}/>
        //                 <div className="filtro-label">
        //                     {
        //                         Array.from({ length: 1 }).map(numero => (
        //                             <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#FFC10E" class="bi bi-star-fill" viewBox="0 0 16 16">
        //                                 <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
        //                             </svg>
        //                         ))
        //                     }
        //                 </div>
        //             </div>
        //         </div>
        //         {/* <div className="separador"></div> */}
                
        //         {/* <div className="separador"></div> */}
        //         <div className="bloque">
        //             <strong>Distancia</strong>
        //             <div className="component-distancia">
        //                 <input 
        //                     type="range"
        //                     min={5}
        //                     max={200}
        //                     step={5}
        //                     value={distanciaTemp}
        //                     onChange={(e)=>{setDistanciaTemp(e.target.value)}}
        //                 />
        //                 <span><span className="textarea" >{Number(distanciaTemp)}</span>km</span>
        //             </div>
        //         </div>
        //         <div className="bloque">
        //             <div className="contenedor-boton-filtro">
        //                 <div className="btn btn-outline-primary" onClick={manejarFiltro}>Filtrar</div>
        //             </div>
        //         </div>
        //     </div>
        // </div>

        <div className="container py-4 border rounded shadow-sm bg-light m-2">
            <h1 className="mb-4 filtro-heading">FILTRAR RESULTADOS</h1>

            <div className="mb-4">
                <strong className="mb-3">Valoración</strong>
                {[5, 4, 3, 2, 1].map((valor) => (
                <div key={valor} className="form-check my-2 d-flex align-items-center cursor-pointer">
                    <input
                        className="form-check-input me-2 cursor-pointer"
                        type="checkbox"
                        value={valor}
                        id={`valor-${valor}`}
                        onClick={handleCheckBox}
                    />
                    <label className="form-check-label d-flex" htmlFor={`valor-${valor}`}>
                        {renderStars(valor)}
                    </label>
                </div>
                ))}
            </div>

            <div className="mb-4">
                <strong className="mb-3">Distancia</strong>
                <div className="component-distancia">
                        <input 
                        className="cursor-pointer"
                        type="range"
                        min={5}
                        max={200}
                        step={5}
                        value={distanciaTemp}
                        onChange={(e)=>{setDistanciaTemp(e.target.value)}}
                    />
                    <span><span className="textarea" >{Number(distanciaTemp)}</span>km</span>
                </div>
            </div>

            <div className="text-end">
                <button className="btn btn-primary w-100" onClick={manejarFiltro}>
                Filtrar
                </button>
            </div>
        </div>
    )
}

export default Filtro;